import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {
  selectActualCompanyId,
  selectActualHasLimitedPocView,
  selectActualLicenses,
  selectActualPermissions,
  selectIsCustomerAccessRestricted,
  selectPartner,
  selectSelfCompanyName,
  selectUserEmail,
} from 'containers/App/selectors'

import Navigation from 'components/pages/navigation'

import { selectIncidentsCount } from '../Polling/selectors'

import {
  selectAccountSetupVisibility,
  selectAwarenessVisibility,
  selectDeepfakeVisibility,
  selectDmarcVisibility,
  selectEncryptionPLGVisibility,
  selectGroupSettingsVisibility,
  selectIncidentsVisibility,
  selectInvestigationVisibility,
  selectMailboxesVisibility,
  selectRedTeamVisibility,
  selectShouldShowPLGDF,
  selectSpearPhishingAgentVisibility,
  selectUserDropdownItems,
} from './selectors'

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)
const mapStateToProps = (state) => ({
  partner: selectPartner(state),
  companyName: selectSelfCompanyName(state),
  userEmail: selectUserEmail(state),
  incidentsCount: selectIncidentsCount(state),
  userDropdownItems: selectUserDropdownItems(state),
  hasLimitedPocView: selectActualHasLimitedPocView(state),
  incidentsVisibility: selectIncidentsVisibility(state),
  investigationVisibility: selectInvestigationVisibility(state),
  awarenessVisibility: selectAwarenessVisibility(state),
  mailboxesVisibility: selectMailboxesVisibility(state),
  groupSettingsVisibility: selectGroupSettingsVisibility(state),
  accountSetupVisibility: selectAccountSetupVisibility(state),
  dmarcVisibility: selectDmarcVisibility(state),
  encryptionPLGVisibility: selectEncryptionPLGVisibility(state),
  deepfakeVisibility: selectDeepfakeVisibility(state),
  redTeamVisibility: selectRedTeamVisibility(state),
  shouldShowPLGDF: selectShouldShowPLGDF(state),
  spearPhishingAgentVisibility: selectSpearPhishingAgentVisibility(state),
  permissions: selectActualPermissions(state),
  licenses: selectActualLicenses(state),
  companyId: selectActualCompanyId(state),
  isAccessRestricted: selectIsCustomerAccessRestricted(state),
})

const render = connect(mapStateToProps, mapDispatchToProps)(Navigation)

export default withRouter(render)
